import { Button, Edit, SaveButton, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import { IncludeAndEditCampaignForm } from "components/forms/frm_parameterize-triggers-templates";
import { FC } from "react";

export const ParameterizeTriggersTemplatesEdit: FC<IResourceComponentsProps> = () => {
  const { goBack, push } = useNavigation();

  const { formProps, saveButtonProps, queryResult } = useForm({
    redirect: false,
    successNotification: {
      type: "success",
      message: "Sucesso",
      description: "Operação realizada com sucesso",
    },
    onMutationSuccess: () => push("/engaging/parameterize-triggers-templates"),
  });

  return (
    <Edit
      headerButtons={[]}
      title="Editar"
      footerButtons={() => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Button onClick={() => goBack()}>Cancelar</Button>

          <SaveButton {...saveButtonProps} icon={null}>
            Salvar
          </SaveButton>
        </div>
      )}
    >
      <IncludeAndEditCampaignForm
        formProps={formProps}
        queryResult={queryResult} />
    </Edit>
  );
};
